import React, { useState, useContext, useCallback, useMemo } from 'react';
import { ApiProvider } from '@/provider/ApiProvider';

interface SidebarNavigationState {
  sidebarStyle: string;
  showSecondaryNav: boolean;
  visibilityCompare: boolean;
  pageTabName: string;
  pageSubTabName: string;
  propertyDetails?: {
    full_name?: string;
    profile_img?: string;
    category_name?: string;
    property_type?: string;
  };
  showSettingsSidebar: boolean;
  contractTermAndCondtionStatus: number;
  secondarySidebarData: {
    backButton?: {
      to: string;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      state?: any;
    };
    isEmpty: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    info: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    links: any[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editButton: any;
    // eslint-disable-next-line
    updateBrandImg: ((event: React.ChangeEvent<HTMLInputElement>) => void) | null;
  };
  activeSettingsLink: { activeSection: string | false; activeName: string; activeUrl: string };
  isHovered: boolean;
  strategicFitTabActive: boolean;
}

// eslint-disable-next-line
type UpdateValueFunction = (property: keyof SidebarNavigationState, newValue: any) => void;

/**
 * This context should be used for all the interactive element that are placed within
 * the sidebar.
 * Since some flyouts, navs etc. cannot be opened directly via prop drilling-we need
 * a global state to handle this.
 */
export const SidebarNavigationContext = React.createContext<
  (SidebarNavigationState & { updateValue: UpdateValueFunction }) | null
>(null);

export const SidebarNavigationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // A storage of all the variables responsible for some elements expand/collapse state.
  const [state, setState] = useState<SidebarNavigationState>({
    sidebarStyle: 'mini',
    showSecondaryNav: false,
    visibilityCompare: false,
    propertyDetails: { full_name: 'asd' },
    pageTabName: '',
    pageSubTabName: '',
    showSettingsSidebar: false,
    contractTermAndCondtionStatus:
      ApiProvider.returnUserData() && ApiProvider.returnUserData()?.is_accept_contract_termcondition
        ? ApiProvider.returnUserData()?.is_accept_contract_termcondition
        : 0,
    secondarySidebarData: {
      isEmpty: true,
      info: {},
      links: [],
      editButton: false,
      updateBrandImg: null,
    },
    isHovered: false,
    activeSettingsLink: { activeSection: false, activeName: '', activeUrl: '' },
    strategicFitTabActive: false,
  });

  // Update the properties we defined in the state.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateValue: UpdateValueFunction = useCallback((property, newValue) => {
    setState((prevState) => ({
      ...prevState,
      [property]: newValue,
    }));
  }, []);

  const contextValue = useMemo(() => ({ ...state, updateValue }), [state, updateValue]);

  return (
    <SidebarNavigationContext.Provider value={contextValue}>
      {children}
    </SidebarNavigationContext.Provider>
  );
};

export const useSidebarNavigation = () => {
  const context = useContext(SidebarNavigationContext);

  if (!context) {
    throw new Error('Something went terribly wrong. Please try again.');
  }

  return context;
};
